import { Container, Grid1, Grid2, Programa, SubPrograma, Beneficio, Info } from "./styles"
import Button from '../../components/Button'
import { CarouselGrid } from '../../components/Carousel/Grid'
import Beneficios3 from '../../assets/beneficios3.png'
import Beneficios2 from '../../assets/beneficios2.png'
import Beneficios1 from '../../assets/beneficios1.png'
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { RiHotelFill } from 'react-icons/ri'
import { FaCalendarCheck, FaMapMarkedAlt, FaUsers } from 'react-icons/fa';

const HomePage = () => {

    return (
        <Container>
            <Grid1>
                <div className='home_text'>
                    <h1>Adquira nosso pacote com 7 diárias anuais e Vai de Férias!</h1>
                </div>
                <div className='justify-center'>
                    <Link to='/tutorial'>
                        <Button format='home' className="text-button">Conheça nosso Programa de Férias</Button>
                    </ Link>
                </div>
            </Grid1>

            <Grid2>
                <h2>Descubra seu destino dos <br /> sonhos</h2>
                <CarouselGrid />
                <div className='justify-center'>
                    <Link to='/destination1'>
                        <Button format='home'>Veja Nossa Oferta de Destinos Completa</Button>
                    </ Link>
                </div>
            </Grid2>
            <div id='hr'> </div>
            
            <Grid2>
                <h2>Somos um Programa de Férias</h2>
                <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis</span>
                <Programa>
                    <SubPrograma>
                        <img src={Beneficios3} alt='programa de férias 1' />
                        <h2>Loren Ipsun</h2>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</span>
                    </SubPrograma>
                    <SubPrograma>
                        <img src={Beneficios3} alt='programa de férias 2' />
                        <h2>Loren Ipsun</h2>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</span>
                    </SubPrograma>
                    <SubPrograma>
                        <img src={Beneficios3} alt='programa de férias 3' />
                        <h2>Loren Ipsun</h2>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</span>
                    </SubPrograma>
                </Programa>
            </Grid2>
            <div id='hr'> </div>

            <Grid2>
                <h2>Benefícios</h2>
                <div className='info'>
                    <span>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis</span>
                    <img src={Beneficios1} alt='porcentagem' className='img' />
                </div>
                <Beneficio>
                    <div className='info-text'>
                        <div id='hr1'> </div>
                        <p>Até 7 diárias para o ano todo <FaCalendarCheck className='img'/></p>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, </span>
                    </div>
                    <div className='info-text'>
                        <div id='hr1'> </div>
                        <p>Até X adultos + Y crianças <FaUsers className='img'/></p>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, </span>
                    </div>
                    <div className='info-text'>
                        <div id='hr1'> </div>
                        <p>Escolha seu hotel favorito <RiHotelFill className='img'/></p>
                        <span>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, </span>
                    </div>
                    <div className='info-text'>
                        <div id='hr1'> </div>
                        <p>Flexibilidade na reserva <FaMapMarkedAlt className='img'/></p>
                        <span>"Sed ut perspicSed ut perspiciatis unde omnis iste natus eiatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, </span>
                    </div>
                </Beneficio>
            </Grid2>
            <div id='hr'> </div>

            <Grid2>
                <h2>Como Fazer Parte</h2>
                <div className='info'>
                    <img src={Beneficios3} alt='como fazer parte' />
                    <div className='text'>
                        <p>Sed uta perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae</p>
                        <Button format='home' style={{width: '9rem'}}>Vamos!</Button>
                    </div>
                </div>
            </Grid2>

            <Info>
                <h3>Pague em 24 meses</h3>
                <Link to='/payment'>
                    <div>
                        <h2>Confira os métodos <br /> de pagamento</h2>
                        <BsArrowRight size={96} style={{marginTop: 50}}/>
                    </div>
                </ Link>
            </Info>
            <div id='hr'> </div>
            <Info>
                <h3 style={{paddingTop: 50}}>Seja um revendedor</h3>
                <span style={{marginLelt: 20}}>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis</span>
                <Link to='/retailer/create'>
                    <div>
                        <h2>Venha fazer parte do <br />nosso time de parceiros</h2>
                        <BsArrowRight size={96} style={{marginTop: 50}}/>
                    </div>
                </ Link>
            </Info>
        </Container>
    )
}

export default HomePage
